// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kDKtL","right":"styles_right__2YYpg"};